import styled from 'styled-components';

export const DocumentosColetaSection = styled.section`
  margin-top: 32px;
  margin-bottom: 1.5rem;
  padding-top: 8px;
  page-break-before: always;
  break-before: page;
`;

export const DocumentosColetaTitle = styled.h2`
  font-size: 18px;
  margin: 0 0 20px;
  color: #152b4e;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const DocumentosColetaPretendenteBlock = styled.div`
  margin-bottom: 28px;
`;

export const DocumentosColetaPage = styled.div`
  margin-bottom: 24px;
  page-break-inside: avoid;
  break-inside: avoid;
`;

export const DocumentosColetaHeader = styled.div`
  border: 2px solid #1d4ed8;
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #fff;
`;

export const DocumentosColetaMeta = styled.div`
  color: #5c6a7a;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const DocumentosColetaPretendenteNome = styled.h3`
  font-size: 15px;
  margin: 8px 0 4px;
  padding-top: 8px;
  border-top: 1px solid #152b4e;
  color: #152b4e;
  font-weight: 700;
`;

export const DocumentosColetaTipoPretendente = styled.div`
  color: #5c6a7a;
  font-size: 13px;
  margin: 0 0 10px;
`;

export const DocumentosColetaTipoDocumento = styled.h4`
  font-size: 13px;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #152b4e;
  font-weight: 700;
`;

export const DocumentosColetaImage = styled.img`
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 80vh;
  object-fit: contain;
  border: 1px solid #e2e8f0;
  background: #fff;
`;

export const DocumentosColetaMissing = styled.div`
  color: #92400e;
  background: #fff7ed;
  border: 1px solid #fdba74;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
`;

export const DocumentosColetaLoading = styled.div`
  padding: 24px 0;
  color: #5c6a7a;
  font-size: 14px;
  text-align: center;
`;

export const DocumentosColetaError = styled.div`
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  font-size: 13px;
`;
